import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { LivePCStatus } from "@/components/landing/LivePCStatus";
import { About } from "@/components/landing/About";
import { Gallery } from "@/components/landing/Gallery";
import { Games } from "@/components/landing/Games";
import { Services } from "@/components/landing/Services";
import { InstagramFeed } from "@/components/landing/InstagramFeed";
import { Hyena } from "@/components/landing/Hyena";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#0A0A0A] text-white antialiased">
      <Header />
      <main>
        <Hero />
        <LivePCStatus />
        <About />
        <Gallery />
        <Games />
        <Services />
        <InstagramFeed />
        <Hyena />
      </main>
      <Footer />
    </div>
  );
}
